export default __webpack_public_path__ + "static/media/Marcelin Pike.1b293267.jpg";